export class Formatter {
  static telefone(valor: string): string {
    const digitos = valor.replace(/\D/g, "").slice(0, 9);
    return (digitos.match(/.{1,3}/g) || []).join(" ");
  }

  /** Máscara do IBAN angolano completo, incluindo o prefixo (2 letras + 2
   * dígitos, ex.: "AO06") como parte editável do mesmo input: agrupa tudo
   * em blocos de 4, ex.: "AO06 0000 1234 5678 9012 3". */
  static iban(valor: string): string {
    const limpo = valor.toUpperCase().replace(/[^A-Z0-9]/g, "");
    const letras = limpo.slice(0, 2).replace(/[^A-Z]/g, "");
    const digitos = limpo.slice(2).replace(/\D/g, "").slice(0, 23);
    const junto = letras + digitos;
    return (junto.match(/.{1,4}/g) || []).join(" ");
  }

  /** Remove o prefixo de um código formatado como "PREFIXO_RESTO" (ex.: código
   * de artigo, código de barras, código de categoria), mantendo só a parte
   * depois do separador — espelha o `SUBSTRING(..., LOCATE('_', ...)+1)` já
   * usado nalgumas queries do backend. Sem separador encontrado, devolve o
   * valor original. */
  static removePrefixo(
    codigo: string | null | undefined,
    separador = "_",
  ): string {
    if (!codigo) return "";
    const indice = codigo.indexOf(separador);
    return indice === -1 ? codigo : codigo.slice(indice + separador.length);
  }

  /** Formata um valor monetário: 10000 -> "10.000,00". Não depende do locale do browser. */
  static moeda(valor: number): string {
    const numero = Number.isFinite(valor) ? valor : 0;
    const [inteiro, decimais] = numero.toFixed(2).split(".");
    const inteiroFormatado = inteiro.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `${inteiroFormatado},${decimais}`;
  }

  /** Máscara de dinheiro ao digitar: os dígitos deslocam-se pelas casas decimais (ex.: "1"->"0,01", "150000"->"1.500,00"). */
  static dinheiro(valorDigitado: string): string {
    const digitos = valorDigitado.replace(/\D/g, "");
    const numero = digitos ? Number(digitos) / 100 : 0;
    return Formatter.moeda(numero);
  }

  /** Converte um valor já formatado ("1.500,00") de volta para número (1500). */
  static paraNumero(valorFormatado: string): number {
    const normalizado = valorFormatado.replace(/\./g, "").replace(",", ".");
    const numero = Number(normalizado);
    return Number.isFinite(numero) ? numero : 0;
  }

  /** Margem de lucro em % sobre o preço de custo: ((venda-custo)/custo)*100.
   * Sem preço de custo (ainda não preenchido, ou artigo tipo Serviço), não há
   * margem calculável. */
  static margemLucro(
    precoCompra: number,
    precoVenda: number,
  ): number | null {
    if (!(precoCompra > 0)) return null;
    return ((precoVenda - precoCompra) / precoCompra) * 100;
  }

  /** Formata uma data ISO com hora: "2026-08-19T14:30:00" -> "19/08/2026 às 14:30". */
  static dataHora(valor: string): string {
    const d = new Date(valor);
    if (Number.isNaN(d.getTime())) return "-";
    const data = d.toLocaleDateString("pt-PT");
    const hora = d.toLocaleTimeString("pt-PT", {
      hour: "2-digit",
      minute: "2-digit",
    });
    return `${data} às ${hora}`;
  }
}
